type OwnProps = {
  id?: string;
  children?: React.ReactNode;
};

const defaultProps: Partial<OwnProps> = {
  id: undefined,
  children: undefined,
};

type Props = OwnProps & typeof defaultProps;

function List({ id, children }: Props) {
  return (
    <div id={id} data-testid={id} className="list">
      {children}
    </div>
  );
}

List.defaultProps = defaultProps;

export default List;
